export default "__VITE_ASSET__C3oVXBR6__"